import endpoints, { formatEndpoint } from '../endpoints';
import { RestManagerWithoutBaseUrl } from '../RestManager';
import { containers, uploadFileToBlobStorage } from './blobHelper';

class BulkUpload {

	static getBulkUploadStatusV2(assetId, startDate, endDate) {
		const endpoint = formatEndpoint(endpoints.BulkUpload.getStatus, { assetId, startDate, endDate });
		return RestManagerWithoutBaseUrl.get(endpoint);
	}

	static getBulkUploadSasUrl(assetId, filename) {
		const endpoint = formatEndpoint(endpoints.BulkUpload.getSasUrl);
		return RestManagerWithoutBaseUrl.post(endpoint, { assetId, filename });
	}

	static startBulkUpload(assetId, bulkUploadFiles) {
		const endpoint = formatEndpoint(endpoints.BulkUpload.startBulkUpload, { assetId });
		return RestManagerWithoutBaseUrl.post(endpoint, { bulkUploadFiles });
	}

	static uploadFile(url, blobname, file) {
		const blobUrl = url?.replace(`${containers.BULK_UPLOAD}/${blobname}`, '');
		return uploadFileToBlobStorage(blobUrl, containers.BULK_UPLOAD, blobname, file, file.size);
	}
}

export default BulkUpload;
